import { API_ENDPOINTS } from '../config';

const SESSION_KEY = 'gwc_auth_telemetry_session_id';
const TELEMETRY_DEDUPE_WINDOW_MS = 5000;
const recentEventMap = new Map();

function getSessionId() {
  let sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = `sess_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
}

function sanitizeObject(details = {}) {
  const sanitized = {};
  Object.entries(details).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (typeof value === 'string') {
      sanitized[key] = value.slice(0, 500);
      return;
    }
    if (typeof value === 'number' || typeof value === 'boolean') {
      sanitized[key] = value;
      return;
    }
    sanitized[key] = JSON.stringify(value).slice(0, 500);
  });
  return sanitized;
}

function buildEventFingerprint(eventName, details = {}) {
  const keys = ['errorCode', 'message', 'errorMessage', 'reason', 'inProgress', 'path'];
  const selected = {};
  keys.forEach((key) => {
    if (details[key] !== undefined && details[key] !== null) {
      selected[key] = details[key];
    }
  });

  return `${eventName}|${window.location.pathname}|${JSON.stringify(selected)}`;
}

function shouldSuppressEvent(eventName, details = {}) {
  const fingerprint = buildEventFingerprint(eventName, details);
  const now = Date.now();
  const lastSentAt = recentEventMap.get(fingerprint);

  if (lastSentAt && now - lastSentAt < TELEMETRY_DEDUPE_WINDOW_MS) {
    return true;
  }

  recentEventMap.set(fingerprint, now);

  if (recentEventMap.size > 100) {
    const cutoff = now - TELEMETRY_DEDUPE_WINDOW_MS;
    for (const [key, timestamp] of recentEventMap.entries()) {
      if (timestamp < cutoff) {
        recentEventMap.delete(key);
      }
    }
  }

  return false;
}

export async function trackAuthTelemetry(eventName, details = {}) {
  if (!eventName) return;
  if (shouldSuppressEvent(eventName, details)) return;

  const payload = {
    eventName,
    timestamp: new Date().toISOString(),
    sessionId: getSessionId(),
    path: window.location.pathname,
    hostname: window.location.hostname,
    userAgent: navigator.userAgent,
    details: sanitizeObject(details)
  };

  try {
    await fetch(`${API_ENDPOINTS.auth}/auth/telemetry`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload),
      keepalive: true
    });
  } catch (error) {
    console.warn('[AuthTelemetry] Failed to send telemetry event', eventName, error);
  }
}
